/*
 * zh-podcast.js
 * Custom Audio-Player für die Magazin-Podcast-Section.
 * Steuert play/pause, Skip-Back-15s, Skip-Forward-30s, Progress-Bar,
 * Zeit-Anzeige und Speed-Cycling. Native <audio> bleibt unsichtbar im DOM,
 * wir steuern es per JS und spiegeln den State in die Custom-UI.
 */
(function () {
  'use strict';

  var SPEED_STEPS = [1, 1.25, 1.5, 1.75, 2, 0.75];

  function formatTime(sec) {
    if (!isFinite(sec) || sec < 0) return '0:00';
    var m = Math.floor(sec / 60);
    var s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' + s : s);
  }

  function initPlayer(root) {
    var audio = root.querySelector('[data-zh-podcast-audio]');
    var playBtn = root.querySelector('[data-zh-podcast-play]');
    var skipBtns = root.querySelectorAll('[data-zh-podcast-skip]');
    var speedBtn = root.querySelector('[data-zh-podcast-speed]');
    var speedLabel = root.querySelector('[data-zh-podcast-speed-label]');
    var progress = root.querySelector('[data-zh-podcast-progress]');
    var fill = root.querySelector('[data-zh-podcast-fill]');
    var current = root.querySelector('[data-zh-podcast-current]');
    var total = root.querySelector('[data-zh-podcast-total]');

    if (!audio || !playBtn) return;

    var speedIndex = 0;
    var isDragging = false;

    function setPlayingState(playing) {
      root.classList.toggle('is-playing', playing);
      playBtn.setAttribute('aria-label', playing ? 'Pausieren' : 'Abspielen');
      playBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    }

    function updateProgress() {
      if (!audio.duration) return;
      var pct = (audio.currentTime / audio.duration) * 100;
      if (fill) fill.style.width = pct + '%';
      if (current) current.textContent = formatTime(audio.currentTime);
      if (progress) progress.setAttribute('aria-valuenow', Math.round(pct));
    }

    function updateDuration() {
      if (total) total.textContent = formatTime(audio.duration);
    }

    function seekFromEvent(clientX) {
      if (!audio.duration || !progress) return;
      var rect = progress.getBoundingClientRect();
      var ratio = (clientX - rect.left) / rect.width;
      ratio = Math.max(0, Math.min(1, ratio));
      audio.currentTime = ratio * audio.duration;
      updateProgress();
    }

    playBtn.addEventListener('click', function () {
      if (audio.paused) {
        var p = audio.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function () { setPlayingState(true); });
    audio.addEventListener('pause', function () { setPlayingState(false); });
    audio.addEventListener('ended', function () { setPlayingState(false); });
    audio.addEventListener('timeupdate', updateProgress);
    audio.addEventListener('loadedmetadata', updateDuration);
    audio.addEventListener('durationchange', updateDuration);

    skipBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var offset = parseFloat(btn.getAttribute('data-zh-podcast-skip')) || 0;
        if (!audio.duration) return;
        audio.currentTime = Math.max(0, Math.min(audio.duration, audio.currentTime + offset));
      });
    });

    if (speedBtn && speedLabel) {
      speedBtn.addEventListener('click', function () {
        speedIndex = (speedIndex + 1) % SPEED_STEPS.length;
        var rate = SPEED_STEPS[speedIndex];
        audio.playbackRate = rate;
        speedLabel.textContent = (rate % 1 === 0 ? rate.toFixed(0) : rate) + '×';
      });
    }

    if (progress) {
      progress.addEventListener('pointerdown', function (e) {
        isDragging = true;
        progress.setPointerCapture(e.pointerId);
        seekFromEvent(e.clientX);
      });
      progress.addEventListener('pointermove', function (e) {
        if (isDragging) seekFromEvent(e.clientX);
      });
      progress.addEventListener('pointerup', function (e) {
        isDragging = false;
        try { progress.releasePointerCapture(e.pointerId); } catch (_) {}
      });
      progress.addEventListener('keydown', function (e) {
        if (!audio.duration) return;
        if (e.key === 'ArrowRight') {
          audio.currentTime = Math.min(audio.duration, audio.currentTime + 5);
          e.preventDefault();
        } else if (e.key === 'ArrowLeft') {
          audio.currentTime = Math.max(0, audio.currentTime - 5);
          e.preventDefault();
        }
      });
    }
  }

  function init() {
    var players = document.querySelectorAll('[data-zh-podcast]');
    players.forEach(initPlayer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
